import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";

function Mouhql() {
const [index, setIndex] = useState(0);
const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "Delivering Highly Qualified Leads That Convert Faster" },
    { text: "From Data to Deals — Power Growth with HQLs" },
    { text: "Smarter Targeting. Higher Conversions. Real Growth" },
  ];

   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
    try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
 closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
  return (
    
    <div>
      <Header />
       <main>
      <AnimatePresence>
               {showSuccessModal && (
                 <motion.div
                   className="modal-overlay show"
                   initial={{ opacity: 0 }}
                   animate={{ opacity: 1 }}
                   exit={{ opacity: 0 }}
                   style={{
                     position: "fixed",
                     top: 0,
                     left: 0,
                     width: "100%",
                     height: "100%",
                     background: "rgba(0,0,0,0.5)",
                     display: "flex",
                     justifyContent: "center",
                     alignItems: "center",
                     zIndex: 9999,
                   }}
                 >
                   <motion.div
                     className="modal show"
                     initial={{ scale: 0.8, opacity: 0 }}
                     animate={{ scale: 1, opacity: 1 }}
                     exit={{ scale: 0.8, opacity: 0 }}
                     transition={{ duration: 0.3 }}
                     style={{
                       background: "#fff",
                       padding: "30px",
                       borderRadius: "10px",
                       width: "400px",
                       textAlign: "center",
                       boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                     }}
                   >
                     <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                       Message Sent!
                     </h2>
                     <p>Thank you for contacting us. We will get back to you shortly.</p>
                     <button className="vc rg lk gh ml il hi gi _l"
                       onClick={() => setShowSuccessModal(false)}
                      
                     >
                       Close
                     </button>
                   </motion.div>
                 </motion.div>
               )}
             </AnimatePresence>
               {/* 🔹 Modal */}
                     {showModal && (
                       <div
                         className={`modal-overlay ${animate ? "show" : ""}`}
                         onClick={(e) => {
                           if (e.target.classList.contains("modal-overlay")) {
                             closeModal();
                           }
                         }}
                         style={{
                           position: "fixed",
                           top: 0,
                           left: 0,
                           right: 0,
                           bottom: 0,
                           background: "rgba(0, 0, 0, 0.5)",
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           zIndex: 1000,
                           opacity: animate ? 1 : 0,
                           transition: "opacity 0.3s ease",
                         }}
                       >
                         <motion.div
                           className="modal-box"
                           initial={{ scale: 0.8, opacity: 0 }}
                           animate={{ scale: 1, opacity: 1 }}
                           exit={{ scale: 0.8, opacity: 0 }}
                           transition={{ duration: 0.3 }}
                           style={{
                             position: "relative",
                             background: "#fff",
                             padding: "30px",
                             borderRadius: "10px",
                             textAlign: "center",
                             boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                           }}
                         >
                           {/* Close button */}
                           <button
                             onClick={closeModal}
                             style={{
                               position: "absolute",
                               top: "10px",
                               right: "15px",
                               background: "transparent",
                               border: "none",
                               fontSize: "22px",
                               cursor: "pointer",
                               color: "#333",
                             }}
                           >
                             ×
                           </button>
             
                           <h2 className="fk tj kk wm bb">
                            Contact Now
                           </h2>
                        <form onSubmit={(e) => handleContactSubmit(e)}>
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
           <input
             type="text"
             name="fullname"
             id="fullname"
             placeholder="Full name"
             value={contactForm.fullname}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
     
         <div className="vd to/2">
           <input
             type="text"
             name="company"
             id="company"
              placeholder="Company name"
             value={contactForm.company}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
       </div>
     
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
           <input
             type="text"
             name="website"
             id="website"
               placeholder="Website"
             value={contactForm.website}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
     
         <div className="vd to/2">
           <input
             type="email"
             name="email"
              placeholder="Email address"
             id="email"
             value={contactForm.email}
             onChange={handleContactChange}
             className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
           />
         </div>
       </div>
     
       <div className="tc sf yo ap zf xi1">
         <div className="vd to/2">
          <input
       type="text"
       name="phone"
       id="phone"
         placeholder="Phone number"
       value={contactForm.phone}
       onChange={(e) => {
         // Allow only digits
         const value = e.target.value.replace(/\D/g, "");
         setContactForm((prev) => ({ ...prev, phone: value }));
       }}
       maxLength={10} // optional: limit to 10 digits
       className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
     />
     
         </div>
       </div>
     
       <div className="fb">
         <textarea
           placeholder="Message"
           rows="3"
           name="message"
           id="message"
           value={contactForm.message}
           onChange={handleContactChange}
           className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
         ></textarea>
       </div>
     
       <div className="tc xf">
           <button
       type="submit"
       className="vc rg lk gh ml il hi gi _l"
       disabled={loading}
     >
       {loading ? "Please wait..." : " Send Message"}
     </button>
     
       </div>
     </form>
                         </motion.div>
                       </div>
                     )}

 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/HQLVideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>


     <section className="i ji ii">
      
      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           ><h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         HQL (Highly Qualified Lead)
        </h2></motion.section>
       
      </div>
      <br/>
      <div className="container">
          <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           >
        <div className="left">
          <img src="/images/qualitylead.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
               initial={{ opacity: 0, y: 100 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
               transition={{
                 duration: 1.8,
                 ease: "easeOut",
                 type: "spring",
                 stiffness: 40,
                 damping: 20,
               }}
             >
         <h3 className="fk tj kk wm bb _b mk">Engage Buyers Actively Looking and Ready to Buy</h3>
          <p className="uo">
            We deliver intent-driven leads that align with your firmographic and demographic criteria—and are actively researching solutions. With HQL, your sales team engages prospects who’ve already raised their hands, so you can prioritize outreach, cut through the noise, and accelerate pipeline velocity.
         </p>
           <div className="tc tf yo zf mb">
            <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("HQL Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
     Get Started 
</button>
          </div>
         </motion.section>
        </div>
      </div>

    </section>

  <section className="i ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      
      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           >
        <h3 className="fk tj kk wm bb _b">Unlock High-Value Opportunities with Intent-Driven Leads</h3></motion.section>
      </div>
      <div className="container">
       
        <div className="right">
             <motion.section
                initial={{ opacity: 0, y: 100 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
                transition={{
                  duration: 1.8,
                  ease: "easeOut",
                  type: "spring",
                  stiffness: 40,
                  damping: 20,
                }}
              >
          <p className="uo">
            We deliver High-Quality Leads (HQLs) tailored for complex B2B sales cycles. Whether you’re selling high-ticket products, navigating multi-step processes, or targeting key decision-makers early, we equip your team with precisely qualified prospects. Our solutions are designed to supercharge your ABM and outbound campaigns by focusing on pre-selected accounts that matter most—so you can prioritize efforts, engage the right stakeholders, and accelerate deals.
         </p>
         </motion.section>
        </div>
      </div>

    </section>

  <section className="i ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      
      <div className="animate_top bb ze rj ki xn vq">
          <motion.section
             initial={{ opacity: 0, y: 100 }}
             whileInView={{ opacity: 1, y: 0 }}
             viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
             transition={{
               duration: 1.8,
               ease: "easeOut",
               type: "spring",
               stiffness: 40,
               damping: 20,
             }}
           >
        <h3 className="fk tj kk wm bb _b">Optimizing Lead Quality with Data-Driven Filters</h3></motion.section>
      </div>
      <div className="container">
       
        <div className="right">
            <motion.section
               initial={{ opacity: 0, y: 100 }}
               whileInView={{ opacity: 1, y: 0 }}
               viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
               transition={{
                 duration: 1.8,
                 ease: "easeOut",
                 type: "spring",
                 stiffness: 40,
                 damping: 20,
               }}
             >
          <p className="uo">
            •	Leads precisely filtered to match your predefined criteria—such as job title, industry, and company size—ensuring the right fit every time. 
            <br/>
            •	Complete with verified contact information and rich engagement context, these leads empower your team to boost conversion rates and close deals faster.
         </p>
          <center>
    <br/>
      <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("HQL Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
     Let's Connect 
</button>
          </center>
           
         </motion.section>
        </div>
      </div>

    </section>


      <section className="ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
         <motion.section
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
            transition={{
              duration: 1.8,
              ease: "easeOut",
              type: "spring",
              stiffness: 40,
              damping: 20,
            }}
          >
        <h3 className="fk tj kk wm bb _b">Precision Meets Performance: HQLs for Scalable ABM Success</h3></motion.section>
      </div>
      <div className="container">
       
        <div className="right">
           <motion.section
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
              transition={{
                duration: 1.8,
                ease: "easeOut",
                type: "spring",
                stiffness: 40,
                damping: 20,
              }}
            >
          <p className="uo">
            Highly Qualified Leads (HQLs) are the fuel that powers successful ABM campaigns. They deliver the precision, intent, and readiness necessary to drive meaningful conversations and close high-value deals faster. When you combine the strategic targeting of ABM with the rigor of HQL qualification, you transform your pipeline into a powerful engine for predictable, scalable growth.
         </p>
        <center>
    <br/>
    <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("HQL Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
      Get Started  
</button></center>
          
         </motion.section>
        </div>
      </div>

    </section>
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Mouhql;
